import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=d6e35820&scoped=true&"
import script from "./UserSettings.vue?vue&type=script&lang=ts&"
export * from "./UserSettings.vue?vue&type=script&lang=ts&"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=d6e35820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e35820",
  null
  
)

export default component.exports